module.exports = __webpack_public_path__ + "img/CCM.c44e1b7f.png";